import { useContext } from "react";
import { SpecificationContextUpdater } from "./SpecificationSessionProvider";

const useSpecificationContextUpdater = () => {
    const context = useContext(SpecificationContextUpdater);
    if (context === undefined) {
        throw new Error("useSpecificationContextUpdate was used outside of it's provider");
    }
    return context;
}

export { useSpecificationContextUpdater }; 